// create a container and set the full-size image as its background
function createOverlay(image) {
  overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.src}')`;
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (overlay.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((overlay.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio, onClose) {
  const overlay = createOverlay(image);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
  overlay.onclick = () => {
    overlay.remove();
    if (onClose) onClose();
  };
  return overlay;
}

function enableZoomOnClick(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  let currentOverlay = null;
  let keyboardX = 50; // Start at center (percentage)
  let keyboardY = 50; // Start at center (percentage)
  const step = 5; // Movement step in percentage

  images.forEach((image) => {
    // Remove any existing click listeners to avoid duplicates
    image.onclick = null;
    // Add click listener to toggle magnify
    image.onclick = (event) => {
      if (currentOverlay) {
        // Click to close zoom
        currentOverlay.remove();
        currentOverlay = null;
      } else {
        // Click to open zoom
        // Reset to center when opening zoom
        keyboardX = 50;
        keyboardY = 50;
        currentOverlay = magnify(image, zoomRatio, () => {
          currentOverlay = null;
        });
        // Set initial position to center
        currentOverlay.style.backgroundPosition = '50% 50%';
        currentOverlay.style.backgroundSize = `${image.width * zoomRatio}px`;
      }
    };
    
    // Add keyboard support on the focusable container
    const container = image.closest('.product__media-container');
    if (container) {
      container.addEventListener('keydown', (event) => {
        // Enter key to toggle zoom (standard activation key)
        if (event.key === 'Enter') {
          event.preventDefault();
          if (currentOverlay) {
            currentOverlay.remove();
            currentOverlay = null;
          } else {
            // Reset to center when opening zoom
            keyboardX = 50;
            keyboardY = 50;
            currentOverlay = magnify(image, zoomRatio, () => {
              currentOverlay = null;
            });
            // Set initial position to center
            currentOverlay.style.backgroundPosition = '50% 50%';
            currentOverlay.style.backgroundSize = `${image.width * zoomRatio}px`;
          }
        }
        // Arrow keys to navigate when zoomed
        else if (currentOverlay && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          
          // Update position based on arrow key
          if (event.key === 'ArrowUp') keyboardY = Math.max(0, keyboardY - step);
          if (event.key === 'ArrowDown') keyboardY = Math.min(100, keyboardY + step);
          if (event.key === 'ArrowLeft') keyboardX = Math.max(0, keyboardX - step);
          if (event.key === 'ArrowRight') keyboardX = Math.min(100, keyboardX + step);
          
          // Apply new position
          currentOverlay.style.backgroundPosition = `${keyboardX}% ${keyboardY}%`;
        }
        // Escape key to close zoom
        else if (event.key === 'Escape' && currentOverlay) {
          currentOverlay.remove();
          currentOverlay = null;
        }
      });
      
      // Remove zoom when focus is lost
      container.addEventListener('blur', () => {
        if (currentOverlay) {
          currentOverlay.remove();
          currentOverlay = null;
        }
      });
    }
  });
}

// Expose function globally for reinitialization after section updates
window.enableZoomOnClick = enableZoomOnClick;

if (window.innerWidth >= 1280) {
  enableZoomOnClick(2);
}
